import { sendGet } from './axios';

export const getPermissionsOfMe = () => sendGet(`/cms/permission/user/me`);
